import { AIFunction } from '@/utils/const';

import { getBasePromptConfig } from './common';
import { ModelIdEnum } from './constants';

export const textToImageModelConfig = [
  {
    modelName: 'Nano Banana Pro',
    modelValue: ModelIdEnum.TEXT_TO_IMAGE_Nano_Banana_Pro,
    iconUrl: '/images/nano-banana.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Image),
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '21:9', value: '21:9' },
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '4:5', value: '4:5' },
            { label: '5:4', value: '5:4' },
            { label: '4:3', value: '4:3' },
            { label: '3:4', value: '3:4' },
            { label: '3:2', value: '3:2' },
            { label: '2:3', value: '2:3' },
            { label: '1:1', value: '1:1' },
          ],
        },
      },
      {
        type: 'radio',
        value: '1k',
        label: 'merror.export.resolution',
        key: 'resolution',
        credit: true,
        config: {
          options: [
            { label: '1k', value: '1k' },
            { label: '2k', value: '2k' },
            { label: '4k', value: '4k' },
          ],
        },
      },
    ],
  },
  {
    modelName: 'Flux Kontext Pro',
    modelValue: ModelIdEnum.TEXT_TO_IMAGE_Flux_Kontext_Pro,
    iconUrl: '/images/flux-kontext-pro.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Image),
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '4:3', value: '4:3' },
            { label: '3:4', value: '3:4' },
            { label: '3:2', value: '3:2' },
            { label: '2:3', value: '2:3' },
            { label: '1:1', value: '1:1' },
            { label: '9:21', value: '9:21' },
            { label: '21:9', value: '21:9' },
          ],
        },
      },
    ],
  },
];
